// eslint-disable-next-line import/prefer-default-export
export const GET_COMPRA_ID = 'GET_COMPRA_ID';
export const UPDATE_COMPRA_ID = 'UPDATE_COMPRA_ID';